<template>
  <div>
    <save-dialog
      title="Asignar chat a compañía"
      :show="show"
      :disable-save-btn="!companyId || isLoading"
      @changeValue="closeModal"
      @save="save">
      <v-layout row wrap slot="content">
        <v-flex xs12>
          <v-select
            v-model="companyId"
            :items="companies"
            :disabled="!companies.length || isLoading"
            item-value="id"
            item-text="name"
            class="white--text"
            label="Seleccione una compañía"
            color="grey"
            autocomplete>
          </v-select>
        </v-flex>
      </v-layout>
    </save-dialog>
  </div>
</template>

<script>
import SaveDialog from '@/components/global/SaveDialogV2';

export default {
  inject: ['$validator'],
  components: {
    SaveDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    chatCenterId: {
      type: Number,
      default: 0,
    },
    companies: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      companyId: null,
      isLoading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit('changeValue', false);
    },
    save() {
      this.isLoading = true;
      this.axios.patch(`chats_center/${this.chatCenterId}`, {
        company_id: this.companyId,
      })
        .then(() => {
          this.$emit('save');
          this.closeModal();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    show(newVal) {
      this.companyId = null;
      this.isLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/AssignChatModal.vue